import { render, staticRenderFns } from "./DisassembleOrderPreview.vue?vue&type=template&id=552e2920&"
import script from "./DisassembleOrderPreview.vue?vue&type=script&lang=js&"
export * from "./DisassembleOrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./DisassembleOrderPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports